import React, {useEffect, useState} from 'react';
import Select from 'react-select';
import {useTranslation} from '../../../hooks/useTranslation';

export default function FuelSelect({
  currentFacility,
  setCurrentFacility,
  facilityData,
  readOnly = false,
}) {
  const {t} = useTranslation();
  const [facilityOptions, setFacilityOptions] = useState([]);

  useEffect(() => {
    if (facilityData) {
      let options = [];
      facilityData?.forEach(item => {
        options = [...options, {label: item?.name, value: item?.id}];
      });
      setFacilityOptions(options);
    }
  }, [facilityData]);

  useEffect(() => {
    if (currentFacility?.stations) {
      let options = [];
      currentFacility?.stations?.forEach(item => {
        options = [...options, {label: item?.name, value: item?.id}];
      });
    }
  }, [currentFacility]);

  return (
    <label htmlFor=''>
      {t('createEquipment.labels.fuelType')}
      <div title={readOnly ? t('createEquipment.readOnly') : undefined}>
      <Select
        options={facilityOptions}
        onChange={selected => {
          if (!readOnly) {
            setCurrentFacility(selected);
          }
        }}
        value={currentFacility}
        isDisabled={readOnly}
        placeholder={t('createEquipment.placeholders.fuelType')}
        styles={{
          control: (baseStyles, state) => ({
            ...baseStyles,
            borderColor: state.isFocused ? '#E9EAEB' : '#E9EAEB',
            borderRadius: 8,
            width: 534,
            height: 42,
            backgroundColor: readOnly ? '#E9EAEB' : '#F4F5F6',
            cursor: readOnly ? 'not-allowed' : 'default',
          }),
        }}
      />
      </div>
    </label>
  );
}
